module.exports = __webpack_public_path__ + "media/flags/jp-6b7497f1.svg";